import { find as _find } from 'lodash';
import { get, post, put, postFormData } from './fetch'


export const getServiceRequestList = (data) => {
    return post(`/api/manager/serviceRequests`, data, true);
}

export const updateRequest = (data) => {
    return put(`/api/manager/updateRequest/${data.requestID}`, data, true);
}

export const getServiceDetails = (id, buyerID) => {
    return post(`/api/manager/request/${id}/detail`, { buyerID }, true);
}

export const getBuyerRequestBids = (singleBuyerRequestID) => {
    return get(`/api/manager/request/${singleBuyerRequestID}/bids`, true);
}

export const uploadServiceRequestImages = (singleBuyerRequestID, images) => {
    return postFormData(`/api/manager/request/${singleBuyerRequestID}/addImage `, images, true);
}

export const acceptBid = (sellerBidHistoryID, singleBuyerRequestID, buyerID, overridePaymentFailure) => {
    return post('/api/manager/acceptbid', { sellerBidHistoryID, singleBuyerRequestID, buyerID, overridePaymentFailure }, true);
}

export const singleBuyerRequestBidsHistory = (singleBuyerRequestID) => {
    return get(`/api/manager/requests/${singleBuyerRequestID}/history`, true);
}

export const searchServiceSeller = (serviceID, searchPhrase) => {
    return post(`/api/manager/service/${serviceID}/sellers`, {searchTerm: searchPhrase}, true);
}

export const placeBid = (singleBuyerRequestID, bid) => {
    return post(`/api/manager/services/requests/${singleBuyerRequestID}/place-bid`, bid);
}

export const getRequestNotes = (singleBuyerRequestID) => {
    return get(`/api/manager/request/${singleBuyerRequestID}/notes`, true);
}

export const getRequestMessages = (singleBuyerRequestID) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/sms`, {} ,true);
    // /request/:singleBuyerRequestID/messages
}

export const sendRequestMessage = (singleBuyerRequestID,messageText,chatType) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/sms/${chatType}/send`, {message : messageText } ,true);
}

export const getLastRequestMessages = (singleBuyerRequestID , lastQueryDate) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/sms`, {lastQueryDate:lastQueryDate} ,true);
}

export const addRequestNotes = (singleBuyerRequestID, data) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/notes/add`, data, true);
}

export const updateBidSellerAvailability = (sellerBidHistoryID, data) => {
    return post(`/api/manager/request/bids/${sellerBidHistoryID}/sellerAvailability/update`, data, true);
}

export const searchSeller = (searchPhrase) => {
    return post(`/api/manager/sellers/search`, {searchTerm: searchPhrase}, true);
}

export const getAllSpecialities = () => {
    return get(`/api/manager/specialities/all`, null, true);
}

export const getAllBadges = () => {
    return get(`/api/manager/badges/all`, null, true);
}

export const getSellerDetailedProfile = (sellerID) => {
    return get(`/api/manager/sellers/${sellerID}/profile/detail`, null, true);
}

export const updateSellerProfile = (sellerID, sellerProfile) => {
    return put(`/api/manager/seller/${sellerID}/profile/update`, sellerProfile,  true);
}

export const addImagesToSellerGallery = (sellerGalleryID, data ) => {
    return postFormData(`/api/manager/seller/gallery/${sellerGalleryID}/images/add`, data,  true);
}

export const deleteSellerGalleryImage = (sellerGalleryID, imageIDs ) => {
    return post(`/api/manager/seller/gallery/${sellerGalleryID}/images/remove`, {imageIDs: imageIDs},  true);
}

export const getSellerGallery = (sellerGalleryID ) => {
    return get(`/api/manager/seller/gallery/${sellerGalleryID}`, null,  true);
}

export const searchSubscribedSeller = (searchPhrase) => {
    return post(`/api/manager/sellers/subscribed/search`, {searchTerm: searchPhrase}, true);
}

export const getSellerPlanCategories = (sellerID) => {
    return get(`/api/manager/sellers/${sellerID}/plan/categories`, true);
}

export const getCategorySpecialities = (categories) => {
    return post(`/api/manager/categories/specialities`, {categories: categories}, true);
}

export const uploadSellerImage = (sellerID, data) => {
    return postFormData(`/api/manager/sellers/${sellerID}/image`, data, true);
}

export const getSellerImage = (sellerID) => {
    return get(`/api/manager/sellers/${sellerID}/image`, true);
}

export const getSellerReviews = (sellerID, status, page, limit) => {
    return post(`/api/manager/sellers/reviews`, {sellerID, status, page, limit}, true);
}

export const getSellerReviewStatus = (sellerID, status) => {
    return get(`/api/manager/sellers/review/status`, true);
}

export const updateSellerReviewStatus = (sellerFeedbackID, status) => {
    return put(`/api/manager/sellers/review/status/update`, {reviewID: sellerFeedbackID, status: status}, true);
}

export const markRequestAsServiced = (singleBuyerRequestID) => {
    return put(`/api/manager/request/${singleBuyerRequestID}/mark-serviced`, {}, true);
}

export const getMarkets = () => {
    return get(`/api/markets/list`, true);
}

export const getSubscriptionList = (page, rowsPerPage, categorySEOName, status, marketID, forChurnCandidates = false, acceptingJobs = 'all', orderByColumn = '') => {
    return post(`/api/manager/subscription/list`, {categorySEOName: categorySEOName, status: status, market: marketID, page: page, rowsPerPage: rowsPerPage, forChurnCandidates: forChurnCandidates, acceptingJobs: acceptingJobs, orderByColumn: orderByColumn}, true);
}

export const enableMessaging = (sbrID) => {
    return get(`/api/manager/request/${sbrID}/sms/enabled`);
}

export const getSnippetsData = (sbrID) => {
    return get(`/api/manager/request/${sbrID}/chat/snippets`);
}

export const sendSourcingMessage = (singleBuyerRequestID,sellerID) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/sourcing/seller/${sellerID}`, {} , true);
}

export const enableSourcingMessageForService = (singleBuyerRequestID) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/sourcing/enabled`, {} , true);
}

export const getFailedCommissionPaymentsList = (page, rowsPerPage, categorySEOName, marketID) => {
    return post(`/api/manager/commission/failed-payments/list`, {categorySEOName: categorySEOName, market: marketID, page: page, rowsPerPage: rowsPerPage}, true);
}

export const saveHomeAddress = (singleBuyerRequestID, address) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/home-address/add`, { address: address }, true);
}

export const getChatUsers = () => {
    return get(`/api/manager/chat/users`, true);
}

export const getSMSChatByUserPhone = (userPhone,lastQueryDate) => {
    return post(`/api/manager/chat/user/${userPhone}`, {lastQueryDate:lastQueryDate} , true);
}

export const sendSMSToMessengerUser = (userPhone, message, userType, userID) => {
    return post(`/api/manager/chat/user/${userPhone}/send`, { message: message, userType: userType, userID: userID }, true);
}

// export const isRequestAssignmentEnabled = () => {
//     return get(`/api/manager/request/assignment/enabled`, {} , true);
// }

export const getManagerUsers = () => {
    return get(`/api/manager/users`, {} , true);
}

export const assignRequestToManager = (sbrID, userID) => {
    return post(`/api/manager/request/${sbrID}/assign`, { assignToUserID: userID }, true);
}

export const getSBRAssignmentList = (date) => {
    return post(`/api/manager/request/assignment/list`, { date: date }, true);
}

export const getManagerAMDashboardData = (queryDateInput) => {
    return post(`/api/manager/am-dashboard/data`,{queryDateInput}, true);
}

export const unassignRequestFromManager = (sbrID) => {
    return post(`/api/manager/request/${sbrID}/unassign`, {}, true);
}

export const toggleTextingForSBR = (sbrID, enabled) => {
    return post(`/api/manager/request/${sbrID}/texting/toggle`, { enabled: enabled }, true);
}

export const getUsersFillRate = (lastDays, userID = undefined) => {
    return post(`/api/manager/fillrate/users`, { lastDays: lastDays, userID: userID }, true);
}

export const getUsersMarketsFillRate = (categoryid = undefined, lastDays, userID) => {
    return post('/api/manager/fillrate/users/markets', { categoryid, lastDays, userID: userID }, true);
}

export const getUsersCategoriesFillRate = (marketid = undefined, lastDays, userID) => {
    return post('/api/manager/fillrate/users/categories', { marketid, lastDays, userID: userID }, true);
}

export const isSubscriptionSearchEnabled = () => {
    return get(`/api/manager/subscription/search/enabled`, {} , true);
}

export const getSubscribedSellerDetails = (sellerID) => {
    return get(`/api/manager/sellers/subscribed/${sellerID}/details`, { sellerID }, true);
}

export const getSellerPaymentMethods = (sellerID, data) => {
    return get(`/api/manager/seller/${sellerID}/payment-methods`, data);
    
}

export const changeLocationForRequest = (singleBuyerRequestID, address) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/location/change`, { address: address }, true);
}

export const prioritizeSellerForJob = (sellerID, prioritize) => {
    return put(`/api/manager/sellers/${sellerID}/prioritized-for-job/update`, { prioritize: prioritize }, true);
}

export const updateBuyer = (buyerID, cellPhone) => {
    return post(`/api/manager/update/buyer`, { buyerID, cellPhone }, true);
}

export const getSellerSingleBuyerRequestsList = (sellerID, lastDays, pageSize, currentPage) => {
    return post(`/api/manager/singleBuyerRequests/seller/list`, { sellerID, lastDays, pageSize, currentPage }, true);
}

// export const checkSMSDeletionEnable = () => {
//     return get(`/api/manager/sms/deletion/enabled`, {}, true);
// }

export const deleteIncomingSms = (smsID) => {
    return post(`/api/manager/sms/incoming/${smsID}/delete`, {}, true);
}

export const getUsersWeeklyFillRate = (lastDays) => {
    return post(`/api/manager/fillrate/users/weekly`, {lastDays}, true);
}

export const sellerSubNinetyDayPayments = (sellerSubID) => {
    return post(`/api/manager/subscription/${sellerSubID}/ninetyDayPayments`, {}, true);
}

export const getSubscriptionPaymentDetails = (sellerID, sellerSubID) => {
    return get(`/api/manager/sellers/${sellerID}/subscriptions/${sellerSubID}/payment/details`, {}, true);
}

export const enableSourcingEmailForService = (singleBuyerRequestID) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/sourcing-email/enabled`, {} , true);
}

export const sendSourcingEmail = (singleBuyerRequestID,sellerID) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/sourcing-email/seller/${sellerID}`, {} , true);
}

export const callSeller = (singleBuyerRequestID, sellerID, phone) => {
    return post(`/api/manager/call/seller/${sellerID}/outbound/initiate`, { sbrID: singleBuyerRequestID, phone: phone }, true);
}

export const callBuyer = (singleBuyerRequestID, buyerID) => {
    return post(`/api/manager/call/buyer/${buyerID}/outbound/initiate`, { sbrID: singleBuyerRequestID }, true);
}

export const endSellerCall = (sellerID, confID) => {
    return post(`/api/manager/call/seller/${sellerID}/outbound/end`, { confID: confID }, true);
}

export const endBuyerCall = (buyerID, confID) => {
    return post(`/api/manager/call/buyer/${buyerID}/outbound/end`, { confID: confID }, true);
}

export const singleBuyerRequestCallHistory = (singleBuyerRequestID) => {
    return get(`/api/manager/requests/${singleBuyerRequestID}/call/history`, true);
}

export const getBuyerCallRecording = (outgoingCallID) => {
    return get(`/api/manager/call/buyer/${outgoingCallID}/recording`, true);
}

export const getSellerCallRecording = (outgoingCallID) => {
    return get(`/api/manager/call/seller/${outgoingCallID}/recording`, true);
}

export const getManagerRequestAssignmentHistory = (managerID, queryDateInput) => {
    return post(`/api/manager/request-assignment/${managerID}/history`, {queryDateInput}, true);
}

export const callRecordingEnabled = () => {
    return get(`/api/manager/call/recording/enabled`, true);
}

export const sendSPSourcingMessage = (singleBuyerRequestID,sellerID) => {
    return post(`/api/manager/request/${singleBuyerRequestID}/access/seller/${sellerID}/generate`, {} , true);
}

export const saveImageASSbrImage = (imageID , buyerID, singleBuyerRequestID) => {
    return post(`/api/manager/save-image-as-sbr-image/${imageID}`, { buyerID , singleBuyerRequestID}, true);
}

export const setPriceConfirmation = (singleBuyerRequestID, price) => {
    return post(`/api/manager/save-confirmation-price/${singleBuyerRequestID}`, {price: price}, true);
}

export const resetPriceConfirmation = (singleBuyerRequestID) => {
    return post(`/api/manager/reset-confirmation-price/${singleBuyerRequestID}`, {}, true);
}

export const getActiveCommOnlyPlans = (categoryID) => {
    return get(`/api/manager/category/${categoryID}/plans/active`, true);
}

export const extendTrialSubscription = (sellerID, sellerSubID, days) => {
    return put(`/api/manager/seller/${sellerID}/subscription/trial/extend`, {sellerID, sellerSubID, days},  true);
}

export const searchBuyersData = (searchPhrase) => {
    return post(`/api/manager/buyersData/search`, {phrase: searchPhrase}, true);
}

export const searchSellersData = (searchPhrase) => {
    return post(`/api/manager/sellersData/search`, {phrase: searchPhrase}, true);
}

export const getLoginLink = (userID) => {
    return get(`/api/manager/users/${userID}/onetimelink`, true);
}

export const getRequestRadiusDetails = (sbrID) => {
    return get(`/api/manager/radiusCheck/${sbrID}`, true);
} 

export const getActualCommissionRevenue = (lastDays=30) => {
    return post('/api/manager/commission/revenue/actual' , {lastDays} , true);
}

export const getActualCommissionRevenueMarketList = (categoryid = undefined, lastDays=30) => {
    return post('/api/manager/commission/revenue/actual/market/list'  , {categoryid, lastDays}, true);
}

export const getMarketActualCommissionRevenue = (marketid, categoryid = undefined, lastDays=30) => {
    return post(`/api/manager/commission/revenue/actual/market/${marketid}`  , {categoryid, lastDays} , true);
}

export const getActualCommissionRevenueCategoryList = (marketid = undefined, lastDays=30) => {
    return post('/api/manager/commission/revenue/actual/category/list'  , {marketid, lastDays} , true);
}

export const getCategoryActualCommissionRevenue = (categoryid, marketid = undefined, lastDays=30) => {
    return post(`/api/manager/commission/revenue/actual/category/${categoryid}` , {marketid, lastDays} , true);
}

export const setSellerPassword = (sellerID, password) => {
    return post(`/api/manager/seller/${sellerID}/password/set`, { password: password}, true);
} 
export const getSellersNotAcceptingJobList = (page, limit) => {
    return post(`/api/manager/sellers/not-accepting-job`, {page, limit}, true);
}

export const getSellerCategoryRadius = (sellerID) => {
    return get(`/api/manager/seller/${sellerID}/subscriptions/radius`, true);
}

export const saveSellerCategoryRadius = (sellerID, radiusVal) => {
    return post(`/api/manager/seller/${sellerID}/subscriptions/radius/save`, { radiusVal }, true);
}

export const getChurnCandidates = (page, rowsPerPage, categorySEOName, marketID, acceptingJobs = 'all') => {
    return post(`/api/manager/churn/candidates`, {categorySEOName: categorySEOName, market: marketID, page: page, rowsPerPage: rowsPerPage, acceptingJobs: acceptingJobs}, true);
}

export const getSellerRadius = (sellerID) => {
    return get(`/api/manager/seller/${sellerID}/radius`, true);
}

export const getSaasMetrics = (page, rowsPerPage, categorySEOName, status, marketID, sellerID, orderByColumn = '', sortDirection = '') => {
    sortDirection = (_.isEmpty(sortDirection) || sortDirection == 'ascending') ? 'ASC' : 'DESC';
    return post(`/api/manager/saas-metrics`, {categorySEOName: categorySEOName, status: status, sellerID: sellerID, market: marketID, page: page, rowsPerPage: rowsPerPage, orderByColumn: orderByColumn, sortDirection: sortDirection}, true);
}